import { ARCHETYPE_ORDER } from '../data/types';
import type { Scores } from '../data/types';

/**
 * Encode scores into a URL hash like #c=85,67,43,91,28,55.
 * Order matches ARCHETYPE_ORDER: servant, devotee, sensualist, primal, brat, little.
 */
export function encodeHash(scores: Scores, name?: string): string {
  const csv = ARCHETYPE_ORDER.map((a) => scores[a]).join(',');
  const namePart = name ? `&n=${encodeURIComponent(name)}` : '';
  return `c=${csv}${namePart}`;
}

export function decodeHash(hash: string): { scores: Scores; name?: string } | null {
  // Accept hash with or without leading #
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const params = new URLSearchParams(raw);
  const csv = params.get('c');
  if (!csv) return null;
  const nums = csv.split(',').map((s) => Number.parseInt(s, 10));
  if (nums.length !== ARCHETYPE_ORDER.length) return null;
  if (nums.some((n) => Number.isNaN(n) || n < 0 || n > 100)) return null;
  const scores: Scores = {
    servant: 0,
    devotee: 0,
    sensualist: 0,
    primal: 0,
    brat: 0,
    little: 0,
  };
  ARCHETYPE_ORDER.forEach((a, i) => {
    scores[a] = nums[i]!;
  });
  const name = params.get('n') ?? undefined;
  return { scores, name };
}

export function makeShareURL(scores: Scores, name?: string): string {
  if (typeof window === 'undefined') return '';
  const { origin, pathname } = window.location;
  return `${origin}${pathname}#${encodeHash(scores, name)}`;
}
